import { configureStore } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/react";

import rootReducer from "./reducers";
import { getModules, setModules } from "../utils/modules";

const overrideModules = getModules();
const initialState = {
  overrideModules,
};
const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState,
  enhancers: (getDefaultEnhancers) => {
    return getDefaultEnhancers().concat(sentryReduxEnhancer);
  },
  devTools: import.meta.env.DEV,
});
store.subscribe(() => {
  // Persist override modules in localStorage
  const state = store.getState();
  const modules = state.overrideModules;
  setModules(modules);
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
